import { render, staticRenderFns } from "./TestEdit.vue?vue&type=template&id=009b4a4a"
import script from "./TestEdit.vue?vue&type=script&lang=js"
export * from "./TestEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports